export function ifShow(show, container, creator, removeChildren, removeHandler) {
  if (removeChildren === void 0) {
    removeChildren = true;
  }
  if (removeHandler === void 0) {
    removeHandler = function removeHandler(g) {
      g.node().removeChildren();
    };
  }
  if (show) {
    return creator(container);
  }
  if (removeChildren) removeHandler(container);
  return null;
}